import React, { useCallback, useEffect, useState } from 'react';
import { GridContainer, Grid} from 'src/shared/grid';
import { Formik, Form } from 'formik';
import { SelectChangeEvent } from '@mui/material/Select';
import { TextField } from '@mui/material';
import { ValidCharacters, errorResponse, formatPhoneNumber, isEmailValid, validateCharacters } from 'src/store/common';
import Button from '@mui/material/Button';
import * as Yup from 'yup';
import { useStoreContext } from 'src/store/context';
import { getContactsCall } from 'src/apis/getFuelSampleCalls';
import { useAddAlert} from '../../store/actions';
import { createUpdateContact } from 'src/apis/mutationsFuelSample';
import { alertMessages } from 'src/constants';

const validateEmail = (value: any):boolean =>{
  if(value){
    if(isEmailValid(value)){
      return true;
    }
    else{
      return false;
    }
  }
  else{
    return true;
  }
}
interface FormVals {
  id: number | null,
  contactName: string,
  phone?: number| null,
  email?: string,
  location?: string,
  position?:string,
  extension?: number|null,
}

export const validationSchema = Yup.object().shape(
    {
        contactName: Yup.string()
          .required('Contact Name is Required'),
        phone: Yup.string().nullable(),
        email: Yup.string().nullable().test('custom-validation', 'Invalid Email', (value)=> validateEmail(value)),
        location: Yup.string().nullable(),
        position: Yup.string().nullable(),
    }
);

type ContactProps ={
  setOpen: any,
  open: boolean,
  setCreateUpdateContactSuccessful: any,
  editContact?: any,
}
export const AddContact: React.FC<ContactProps> = ({setOpen, open, editContact, setCreateUpdateContactSuccessful}) =>{
	const [,dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const [, setContactCallComplete] = useState<boolean>(false);
  const [ initVals, setInitVals] = useState<FormVals>({ 
    id: null,
    contactName:'',
    phone:null,
    email: '',
    location: '',
    position: '',
    extension: null,
  })

  const getContacttoEdit= useCallback((request: any) => {
    (async () => {
      try {
        const contactPromise: any = await getContactsCall(request);
        if(contactPromise){
          const editingContact = contactPromise?.contacts[0];
          setInitVals({
            id: editingContact.contactId,
            contactName: editingContact.contactName,
            phone: editingContact.contactPhone,
            extension: editingContact.contactExtension,
            email: editingContact.contactEmail,
            position: editingContact.title,
            location: editingContact.location
          });
        }
      } catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.retrieveContacts);
      }
    })();
  }, [ addAlert,]);

  const handleSubmit= (values:any)=>{
    (async () => {
      try {
        const updateCreateContactPromise: any = await createUpdateContact(null, addAlert, values);
        if(updateCreateContactPromise){
          setOpen(false);
          setCreateUpdateContactSuccessful(true);
        }
      } catch(error:any){    
        if(error?.message){
          errorResponse(error, addAlert, alertMessages.saveContacts);

        }
        else{
          let errorMsg = error[0].message;
          if(errorMsg.includes(alertMessages.saveUniqueContacts)){
            errorResponse(error, addAlert, alertMessages.saveUniqueContacts);
          } else {
            errorResponse(error, addAlert, alertMessages.saveContacts);
          }
        }
      }
    })();
  }

  useEffect(()=>{
    if(editContact){
      const requestForEditContact = {
        setContactCallComplete: setContactCallComplete,
        addAlert: useAddAlert,
        returnAll: false,
        page: null, 
        perPage: null,
        contactId: editContact.contactId,
        filterByLocation:null,
        filterByTitle: null,
      };
      getContacttoEdit(requestForEditContact);
    }
    else{
      setInitVals({ 
        id: null,
        contactName:'',
        phone:null,
        email: '',
        location: '',
        position: '',
        extension: null
      })
    }
  },[editContact, getContacttoEdit])

  return(
  <GridContainer className="removePadding">
    <Grid row gap="md" className='page-heading'>
      <Grid
        desktop={{col:12}}
        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
          {
            editContact ? (
              <span className="font-sans-lg text-bold">Edit Contact</span>
            ):(
              <span className="font-sans-lg text-bold">Add New Contact</span>
            )
          }
      </Grid>
    </Grid>
    <hr style={{width: '100%', marginBottom: 0}}></hr>

    <Formik
      initialValues={initVals}
      validateOnBlur={true}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => handleSubmit(values) }>
      {({
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        handleBlur,
        isValid,
        setFieldTouched
      }) => { 
          const setContactName =(event: SelectChangeEvent) =>{
            setFieldTouched('contactName')
            if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
              return
            }
            setFieldValue('contactName', event.target.value);
          };
          const setContactPhone =(event: SelectChangeEvent) =>{
            setFieldTouched('phone')
            if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
              return
            }
            setFieldValue('phone', event.target.value);
          };
          const setExtension =(event: SelectChangeEvent) =>{
            setFieldTouched('extension')
            if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
              return
            }
            setFieldValue('extension', event.target.value);
          };
          const setEmail =(event: SelectChangeEvent) =>{
            setFieldTouched('email')
            if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
              return
            }
            setFieldValue('email', event.target.value);
          };
          const setPosition =(event: SelectChangeEvent) =>{
            setFieldTouched('position')
            if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
              return
            }
            setFieldValue('position', event.target.value);
          };
          const setLocation =(event: SelectChangeEvent) =>{
            setFieldTouched('location')
            if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
              return
            }  
            setFieldValue('location', event.target.value);
          };
          const emailKeyDown = (e: any)=>{
            if(e.key ==='@' && values.email && (values.email).includes('@')){
              e.preventDefault();
            }
          }
        return(
          <Form onSubmit={handleSubmit}>
            <div className="smooth-scrollbar paddingForm" style={{maxHeight: '45vh', paddingBottom: '2rem'}}>
            <Grid row gap="md">
                <Grid desktop={{ col: 6 }}>
                  <label htmlFor={`contactName`} id='contactName'>Contact Name *</label>
                </Grid>
                <Grid desktop={{ col: 4 }}>
                  <label htmlFor={`contactPhone`} id='contactPhone'>Government Phone</label>
                </Grid>
                <Grid desktop={{ col: 2}}>
                  <label htmlFor={`contactExtension`} id='contactExtension'>Ext.</label>
                </Grid>
              </Grid>
              <Grid row gap="md">
                <Grid desktop={{ col: 6}}>
                  <TextField
                    value={values.contactName}
                    onBlur={handleBlur}
                    error={!!errors.contactName && !!touched.contactName}
                    helperText={!!errors.contactName && !!touched.contactName ? errors.contactName : ''}
                    id='contactName'
                    type='string'
                    onInput={(e) => validateCharacters(e, ValidCharacters.Alpha, ValidCharacters.Numeric, '.', '-', ' ', "'")}
                    size='medium'
                    fullWidth
                    onChange={(e: any) => setContactName(e)}
                    placeholder='Enter Contact Name'
                  />
                </Grid>
                <Grid desktop={{ col: 4}}>
                  <TextField
                    placeholder='_ _ _ - _ _ _ - _ _ _ _'
                    value={formatPhoneNumber(values?.phone? values.phone: '')}
                    onBlur={handleBlur}
                    error={!!errors.phone && !!touched.phone}
                    helperText={!!errors.phone && !!touched.phone ? errors.phone : ''}
                    id='contactPhone'
                    type='string'
                    onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                    size='medium'
                    fullWidth
                    onChange={(e: any) => setContactPhone(e)}
                  />
                </Grid>
                <Grid desktop={{ col: 2}}>
                  <TextField
                    placeholder='Ext.'
                    value={values.extension}
                    onBlur={handleBlur}
                    error={!!errors.phone && !!touched.extension}
                    helperText={!!errors.extension && !!touched.extension ? errors.extension : ''}
                    id='contactExtension'
                    type='string'
                    onInput={(e) => validateCharacters(e,ValidCharacters.Numeric)}
                    size='medium'
                    fullWidth
                    onChange={(e: any) => setExtension(e)}
                  />
                </Grid>
              </Grid>
              <Grid row gap="md">
                <Grid desktop={{ col: 6 }}>
                  <label htmlFor={`email`} id='email'>Government Email</label>
                </Grid>
                <Grid desktop={{ col: 6 }}>
                  <label htmlFor={`positionTitle`} id='positionTitle'>Position Title</label>
                </Grid>
              </Grid>
              <Grid row gap="md">
                <Grid desktop={{ col: 6}}>
                  <TextField
                    value={values.email}
                    onBlur={handleBlur}
                    error={!!errors.email && !!touched.email}
                    helperText={!!errors.email && !!touched.email ? errors.email : ''}
                    id='email'
                    type='string'
                    onKeyDown={emailKeyDown}
                    size='medium'
                    fullWidth
                    onChange={(e: any) => setEmail(e)}
                    placeholder='Enter Government Email'
                  />
                </Grid>
                <Grid desktop={{ col: 6}}>
                  <TextField
                    placeholder='Enter Position Title'
                    value={values.position}
                    onBlur={handleBlur}
                    error={!!errors.position && !!touched.position}
                    helperText={!!errors.position && !!touched.position ? errors.position : ''}
                    id='positionTitle'
                    type='string'
                    onInput={(e) => validateCharacters(e, ValidCharacters.Alpha, ValidCharacters.Numeric, '.', ' ')}
                    size='medium'
                    fullWidth
                    onChange={(e: any) => setPosition(e)}
                  />
                </Grid>
              </Grid>
              <Grid row gap="md">
              <Grid desktop={{ col: 6 }}>
                  <label htmlFor={`location`}  id='location'>Contact Location</label>
                </Grid>
              </Grid>
              <Grid row gap="md">
                <Grid desktop={{ col: 6}}>
                  <TextField
                    value={values.location}
                    onBlur={handleBlur}
                    error={!!errors.location && !!touched.location}
                    helperText={!!errors.location && !!touched.location ? errors.location : ''}
                    id='location'
                    type='string'
                    onInput={(e) => validateCharacters(e, ValidCharacters.Alpha, ValidCharacters.Numeric, '.', ',', '-',' ')}
                    size='medium'
                    fullWidth
                    onChange={(e: any) => setLocation(e)}
                    placeholder='Enter Contact Location'
                  />
                </Grid>
              </Grid>
            </div>

            <Grid row className='modalBottomDiv'>
              <Grid desktop={{col:10}} className="modalCancelDiv">
                <Button variant="outlined" style={{backgroundColor: 'white'}} onClick={()=>{setOpen(!open)}}>
                  Cancel
                </Button>
              </Grid> 
              {
                editContact? (
                  <Grid desktop={{col:2}} className='modalSubmitDiv'>
                    <Button variant="contained" type="submit" disabled={!isValid}>
                      Save
                    </Button>
                  </Grid>
                ) : (
                  <Grid desktop={{col:2}} className='modalSubmitDiv'>
                    <Button variant="contained" type="submit" disabled={!isValid}>
                      Add
                    </Button>
                  </Grid>
                )
              }
            </Grid>
          </Form>
      )}}
    </Formik>
  </GridContainer>
  )
}